import script from "./EditProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProductPopup.vue?vue&type=script&setup=true&lang=js"

import "./EditProductPopup.vue?vue&type=style&index=0&id=e66f8c10&lang=scss"

const __exports__ = script;

export default __exports__